module.exports = __webpack_public_path__ + "static/media/loginBackground.5fb39db9.png";